type DeskRow = {
  time: string;
  title: string;
  status: string;
  tone: 'ready' | 'active' | 'soon';
};

const TONE = {
  ready: 'bg-emerald-400/15 text-emerald-300',
  active: 'bg-white/10 text-slate-200',
  soon: 'bg-amber-400/15 text-amber-200',
} as const;

export function DeskPreview({
  caption,
  labels,
  rows,
}: {
  caption: string;
  labels: { fleet: string; active: string; ready: string; returns: string };
  rows: DeskRow[];
}) {
  const figures = [
    { label: labels.fleet, value: '24' },
    { label: labels.active, value: '11' },
    { label: labels.ready, value: '9' },
    { label: labels.returns, value: '3' },
  ];

  return (
    <figure className="overflow-hidden rounded-2xl border border-white/10 bg-[#0F172A] text-[#E2E8F0] shadow-2xl shadow-stone-950/30">
      <div className="flex items-center gap-2 border-b border-white/10 px-4 py-2.5">
        <span className="h-2 w-2 rounded-full bg-[#FF8A00]" />
        <span className="text-[11px] font-semibold tracking-wide text-slate-300">fleetava · desk</span>
      </div>
      <div className="grid grid-cols-2 gap-2 p-3 sm:grid-cols-4">
        {figures.map((figure) => (
          <div key={figure.label} className="rounded-xl border border-white/10 bg-[#1E293B] px-3 py-2.5">
            <p className="text-lg font-semibold tabular-nums leading-none">{figure.value}</p>
            <p className="mt-1 text-[10px] font-medium text-slate-400">{figure.label}</p>
          </div>
        ))}
      </div>
      <ul className="space-y-1.5 px-3 pb-3">
        {rows.map((row) => (
          <li key={row.title} className="flex items-center justify-between gap-3 rounded-xl border border-white/10 bg-[#1E293B]/80 px-3 py-2">
            <span className="min-w-0">
              <span className="block text-[10px] font-semibold uppercase tracking-wide text-slate-500">{row.time}</span>
              <span className="block truncate text-xs font-semibold">{row.title}</span>
            </span>
            <span className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold ${TONE[row.tone]}`}>
              {row.status}
            </span>
          </li>
        ))}
      </ul>
      <figcaption className="border-t border-white/10 px-4 py-2 text-[10px] leading-relaxed text-slate-400">
        {caption}
      </figcaption>
    </figure>
  );
}
